/* =============================================================================
   Farmoxa Premium — small global behaviours (quantity steppers on cards, scroll reveal)
   ============================================================================= */
(() => {
  'use strict';
  /* Scroll reveal (theme setting "Animaties" → body.fmx-anim). Elements with [data-fmx-reveal] fade/slide in when they
     enter the viewport; --i on the element staggers siblings. The hidden start state only applies once this script has
     run (body.fmx-anim-ready), so content is never hidden when JS fails; reduced motion → no animation. */
  const body = document.body;
  if (body.classList.contains('fmx-anim') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    body.classList.add('fmx-anim-ready');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    const watch = (root) => root.querySelectorAll('[data-fmx-reveal]:not(.is-in)').forEach((el) => io.observe(el));
    watch(document);
    document.addEventListener('shopify:section:load', (e) => { e.target.querySelectorAll('[data-fmx-reveal]').forEach((el) => el.classList.add('is-in')); });
    // safety net: anything still hidden after 2.5s (e.g. inside a hidden tab panel) is shown
    setTimeout(() => document.querySelectorAll('[data-fmx-reveal]:not(.is-in)').forEach((el) => { const r = el.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) el.classList.add('is-in'); }), 2500);
  }
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-fmx-qty-minus]');
    const plus = e.target.closest('[data-fmx-qty-plus]');
    if (!minus && !plus) return;
    const wrap = (minus || plus).closest('[data-fmx-qty]');
    const input = wrap?.querySelector('input');
    if (!input) return;
    const step = parseInt(input.step || '1', 10) || 1;
    const min = parseInt(input.min || '1', 10) || 1;
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    let v = parseInt(input.value || '1', 10) || min;
    v = minus ? Math.max(min, v - step) : Math.min(max, v + step);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
